console.log("[Shreyasi] preorder ack script loaded");

(function () {
  const MODAL_ID = "PreorderAckModal";
  const ACK_FLAG = "__shreyasi_preorder_ack_in_progress";

  // Prevent double-confirm/double-add
  let confirming = false;

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function isDrawerMode() {
    try {
      return String(window.theme?.settings?.cartType || "").toLowerCase() === "drawer";
    } catch (e) {
      return false;
    }
  }

  function openModal(message) {
    const modal = getModal();
    if (!modal) return;

    const text = qs("#PreorderAckText", modal);
    if (text) text.textContent = message;

    modal.hidden = false;

    const confirmBtn = qs("[data-preorder-confirm]", modal);
    if (confirmBtn) confirmBtn.focus();
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = true;
  }

  function isPreorderButton(btn) {
    if (!btn) return false;
    const v = String(btn.getAttribute("data-shreyasi-preorder") || "").toLowerCase();
    return v === "true" || v === "1";
  }

  function getButtonMeta(btn) {
    return {
      dispatch: String(btn.getAttribute("data-shreyasi-dispatch-timeline") || "").trim(),
      addon: String(btn.getAttribute("data-shreyasi-addon-timeline") || "").trim()
    };
  }

  function buildMessage(meta) {
    const parts = [];
    parts.push("This item is available for pre-order.");
    if (meta.dispatch) parts.push(`Estimated dispatch within ${meta.dispatch}.`);
    if (meta.addon) parts.push(`Optional services may add an additional ${meta.addon}.`);
    parts.push("By proceeding, you acknowledge that this is a pre-order item.");
    return parts.join(" ");
  }

  function upsertHiddenProperty(form, key, value) {
    if (!form) return;
    const name = `properties[${key}]`;

    let el;
    try {
      el = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    } catch (e) {
      // CSS.escape fallback not needed in modern browsers, but stay safe
      el = form.querySelector(`input[name="${name.replace(/"/g, '\\"')}"]`);
    }

    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  function removeHiddenProperty(form, key) {
    if (!form) return;
    const name = `properties[${key}]`;

    let el;
    try {
      el = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    } catch (e) {
      el = form.querySelector(`input[name="${name.replace(/"/g, '\\"')}"]`);
    }

    if (el) el.remove();
  }

  function submitFormInThemeWay(form, btn) {
    // Clicking the real ATC button is best because theme/apps hook into it
    if (btn && typeof btn.click === "function") {
      btn.click();
      return;
    }

    // requestSubmit triggers submit handlers better than form.submit()
    if (form && typeof form.requestSubmit === "function") {
      form.requestSubmit();
      return;
    }

    // Last resort
    if (form) form.submit();
  }

  // -------- Drawer open (Impulse-safe) --------
  function openDrawerAfterCartUpdate() {
    // Drawer mode only (do nothing on /cart page)
    if (window.location.pathname === "/cart") return;
    if (!isDrawerMode()) return;

    const opener =
      document.querySelector('[data-drawer-trigger="cart"]') ||
      document.querySelector(".js-drawer-open-cart") ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[data-cart-drawer-open]');

    if (opener) {
      opener.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
      return;
    }

    const drawer =
      document.querySelector("#CartDrawer") ||
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector(".cart-drawer");

    if (drawer && typeof drawer.open === "function") {
      drawer.open();
    }
  }

  function waitForThemeCartUpdateThenOpenDrawer() {
    if (!isDrawerMode()) return;

    let done = false;

    const finish = () => {
      if (done) return;
      done = true;
      cleanup();

      // Small delay to let DOM settle
      setTimeout(openDrawerAfterCartUpdate, 60);
    };

    const cleanup = () => {
      document.removeEventListener("cart:updated", finish);
      document.removeEventListener("cart:refresh", finish);
      document.removeEventListener("ajaxProduct:added", finish);
      document.removeEventListener("cart:change", finish);
      document.removeEventListener("cart:afterAdd", finish);
    };

    document.addEventListener("cart:updated", finish, { once: true });
    document.addEventListener("cart:refresh", finish, { once: true });
    document.addEventListener("ajaxProduct:added", finish, { once: true });
    document.addEventListener("cart:change", finish, { once: true });
    document.addEventListener("cart:afterAdd", finish, { once: true });

    // Absolute fallback: open anyway if theme emits nothing
    setTimeout(() => {
      if (!done) finish();
    }, 1400);
  }

  function attach() {
    const modal = getModal();
    if (!modal) return;

    let pending = null; // { form, btn, meta }

    // Modal click handling
    modal.addEventListener("click", (e) => {
      const t = e.target;

      // Cancel/close
      if (t.matches("[data-preorder-close], [data-preorder-cancel]")) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        pending = null;
        confirming = false;
        closeModal();
        return;
      }

      // Confirm
      if (t.matches("[data-preorder-confirm]")) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        const job = pending;
        pending = null;
        closeModal();

        if (!job) return;

        // Block double confirm
        if (confirming) return;
        confirming = true;

        // Mark as acked so our intercept lets the next click go through
        job.form[ACK_FLAG] = true;

        // Inject proof trail properties into the REAL product form
        upsertHiddenProperty(job.form, "Preorder", "Yes");
        if (job.meta.dispatch) upsertHiddenProperty(job.form, "Dispatch timeline", job.meta.dispatch);
        if (job.meta.addon) upsertHiddenProperty(job.form, "Add-on timeline", job.meta.addon);
        upsertHiddenProperty(job.form, "Preorder acknowledged", "Yes");

        // If in Drawer mode, open drawer after theme finishes updating cart
        if (isDrawerMode()) {
          waitForThemeCartUpdateThenOpenDrawer();
        }

        // Trigger the theme/app normal ATC flow (this is what makes Globo add-ons become line items)
        submitFormInThemeWay(job.form, job.btn);

        // Cleanup so preorder props cannot leak into later adds
        setTimeout(() => {
          try {
            job.form[ACK_FLAG] = false;
          } catch (_) {}

          confirming = false;

          removeHiddenProperty(job.form, "Preorder");
          removeHiddenProperty(job.form, "Dispatch timeline");
          removeHiddenProperty(job.form, "Add-on timeline");
          removeHiddenProperty(job.form, "Preorder acknowledged");
        }, 2000);
      }
    });

    // Escape closes modal
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const m = getModal();
        if (m && !m.hidden) {
          pending = null;
          confirming = false;
          closeModal();
        }
      }
    });

    // Intercept preorder add-to-cart BEFORE theme handlers
    document.addEventListener(
      "click",
      (e) => {
        const btn =
          e.target.closest("[data-add-to-cart]") ||
          e.target.closest('button[name="add"]') ||
          e.target.closest('button[type="submit"]');

        if (!btn) return;
        if (!isPreorderButton(btn)) return;

        const form = btn.closest('form[action^="/cart/add"]');
        if (!form) return;

        // If confirm just happened, let the theme handle this click normally
        if (form[ACK_FLAG]) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        const meta = getButtonMeta(btn);
        pending = { form, btn, meta };
        openModal(buildMessage(meta));
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach);
  } else {
    attach();
  }
})();